import {
  agendaMagasinMock,
  cartesDynamiquesMock,
  encartInfosMagasinMock,
  encartMiseEnAvantMock,
  heroSliderMock,
  pushRealisationsClientsMock,
  sliderCartesImageNomMock,
  texteSeoVisuelBasMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  heroSliderMock,
  encartInfosMagasinMock,
  agendaMagasinMock,
  sliderCartesImageNomMock,
  pushRealisationsClientsMock,
  cartesDynamiquesMock,
  encartMiseEnAvantMock,
  texteSeoVisuelBasMock,
];

export const magasinMock: SlugPage = {
  ...pageBase({
    title: 'Magasins',
    type: 'magasin',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: true,
    // Real Annecy uuid on preprod, the default target of environment.local.ts: without it the
    // Elastic-fed blocks of a store page (team) have no store to query and stay empty.
    context: { name: `SoCoo'c Annecy`, uuid: '1f02ff8b-edcc-60f2-b2f4-efd44f4b8cf1' },
  }),
  blocks,
};
